<template>
  <div class="ui main container">
    <h2>Detalles del pedido #{{ order.reference }}</h2>

    <div class="ui three unstackable top attached mini steps">
      <div class="step completed">
        <i class="check icon"></i>
        <div class="content">
          <div class="title">Pedido creado</div>
          <div class="description"></div>
        </div>
      </div>
      <div class="step" :class="getStepStatus(2)">
        <i class="money icon"></i>
        <div class="content">
          <div class="title">Pago confirmado</div>
          <div class="description"></div>
        </div>
      </div>
      <div class="step" :class="getStepStatus(3)">
        <i class="truck icon"></i>
        <div class="content">
          <div class="title">Pedido enviado</div>
          <div class="description"></div>
        </div>
      </div>
    </div>
    <div class="ui blue inverted segment" v-html="message"></div>
    <OrderDetails :order="order" />
  </div>
</template>

<script>
import OrderDetails from '../../components/order/OrderDetails';

export default {
  name: 'Order',
  computed: {
    order: function() {
      return this.$store.getters['orders/getOrder'];
    },
    message: function() {
      return this.$store.getters['application/getOrdersMessage'];
    }
  },
  created: async function() {
    console.log('fetch order details');
    await this.$store.dispatch('orders/getOrderById', this.$route.params['id']);
  },
  methods: {
    getStepStatus: function(step) {
      if (step === 2) {
        return this.order.status === 'PAYMENT_ACCEPTED' ||
          this.order.status === 'SHIPPED'
          ? 'completed'
          : 'disabled';
      } else if (step === 3) {
        return this.order.status === 'SHIPPED' ? 'completed' : 'disabled';
      }
    }
  },
  components: {
    OrderDetails
  }
};
</script>

<style lang="css" scoped></style>
